import { render, staticRenderFns } from "./Lgx195962266451968000.vue?vue&type=template&id=b0617da4&"
import script from "./Lgx195962266451968000.vue?vue&type=script&lang=js&"
export * from "./Lgx195962266451968000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports